var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoadblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.35 6.73684V7.6C10.35 7.82091 10.5291 8 10.75 8H12.0484L12.7544 10.1053H3.2456L4.3752 6.73684H10.35ZM9.81868 1.35H8.4C8.17909 1.35 8 1.52909 8 1.75V5.05263H4.94L6.4456 0.561684C6.50071 0.397423 6.60286 0.255194 6.73797 0.154597C6.87308 0.0540007 7.03451 -1.27402e-05 7.2 2.25406e-09H8.8C8.96549 -1.27402e-05 9.12692 0.0540007 9.26203 0.154597C9.39714 0.255194 9.49929 0.397423 9.5544 0.561684L9.81868 1.35ZM2.6816 11.7895H13.3192L14.1664 14.3158H16V16H0V14.3158H1.8336L2.6816 11.7895Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 0.2C13.55 0.0895433 13.4605 0 13.35 0H11.65C11.5395 0 11.45 0.089543 11.45 0.2V2.24863C11.45 2.35909 11.3605 2.44863 11.25 2.44863H9.2C9.08954 2.44863 9 2.53818 9 2.64863V4.35137C9 4.46182 9.08954 4.55137 9.2 4.55137H11.25C11.3605 4.55137 11.45 4.64091 11.45 4.75137V6.8C11.45 6.91046 11.5395 7 11.65 7H13.35C13.4605 7 13.55 6.91046 13.55 6.8V4.75137C13.55 4.64091 13.6395 4.55137 13.75 4.55137H15.8C15.9105 4.55137 16 4.46182 16 4.35137V2.64863C16 2.53818 15.9105 2.44863 15.8 2.44863H13.75C13.6395 2.44863 13.55 2.35909 13.55 2.24863V0.2Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoadblock);
export default __webpack_public_path__ + "static/media/icon--roadblock.ee4bd905e3321e36621f6dab11d047e1.svg";
export { ForwardRef as ReactComponent };